<template>
  <v-app-bar
    app :flat="!scrolled"
    class="nav-bar-container"
    :class="[
      scrolled ? 'scrolled' : 'unscrolled',
      this.toolbarColor ? 'background-' + this.toolbarColor : '',
    ]" >
    <slot>
      <v-toolbar-title class="headline text-uppercase">
        <logo
          :color="scrolled ? 'white' : logoColor"
          :small="$vuetify.breakpoint.mdAndDown"
        />
      </v-toolbar-title>
      <v-spacer />

      <button
        v-if="$vuetify.breakpoint.mdAndDown"
        class="default-btn text"
        @click="$emit('toggleSidenav')"
      ><v-icon size="36">mdi-reorder-horizontal</v-icon></button>

      <nav v-if="$vuetify.breakpoint.lgAndUp" class="client-nav">

        <v-menu
          v-for="menu of menuItems"
          :key="menu.text"
          content-class="client-nav" :close-on-content-click="true" offset-y>
          <template v-slot:activator="{ on }">
            <button class="default-btn text nav-menu-item" v-on="on">
              {{ menu.text }}
            </button>
          </template>

          <v-list>
            <v-list-item
              v-for="child of menu.children"
              :key="child.text"
              :to="child.to">
              <v-list-item-title>{{ child.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <template v-if="!isAuthenticated">
          <router-link
            :to="{ name: 'SignUp' }"
            class="default-btn text signup"
          >Sign Up</router-link>

          <router-link
            :to="{ name: 'SignIn' }"
            class="default-btn blue subdued-hover"
          >Login</router-link>
        </template>

        <v-menu v-else content-class="client-nav" :close-on-content-click="true" offset-y>
          <template v-slot:activator="{ on }">
            <button class="default-btn text nav-menu-item" v-on="on">
              My Profile
              <v-icon>mdi-chevron-down</v-icon>
            </button>
          </template>

          <v-list>
            <v-list-item :to="{ name: 'LenderResults' }">
              <v-list-item-title>My Dashboard</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="userData.role === 'admin'"
              :to="{ name: 'AdminDashboard' }"
            >
              <v-list-item-title>Admin Site</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="userData.role === 'lender' && !userData.organization.hidden"
              :to="{
                name: 'OrganizationDashboard',
                params: { organizationId: userData.organizationId }
              }"
            >
              <v-list-item-title>My Organization Dashboard</v-list-item-title>
            </v-list-item>

            <v-list-item :to="{ name: 'AccountSettings' }">
              <v-list-item-title>Account Settings</v-list-item-title>
            </v-list-item>

            <v-list-item @click="onLogout">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </nav>
    </slot>
  </v-app-bar>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Navbar',
  props: {
    logoColor: {
      type: String,
      default: 'black',
    },
    toolbarColor: String,
  },
  data: () => ({
    menuItems: [
      {
        text: 'Resource Center',
        children: [
          {
            text: 'Amortization Calculator',
            to: { name: 'AmortizationCalculator' },
          },
          // hide for now until providers feature is ready to show
          // {
          //   text: 'Providers',
          //   to: { name: 'ProvidersList' },
          // },
        ],
      },
      {
        text: 'About',
        children: [
          {
            text: 'About us',
            to: { name: 'About' },
          },
          {
            text: 'FAQs',
            to: { name: 'Faq' },
          },
        ],
      },
    ],
    showMenu: false,
  }),
  computed: {
    ...mapState({
      scrolled: ({ scrolled }) => scrolled,
    }),
    ...mapState('authStore', {
      userData: 'userData',
      isAuthenticated: state => !!state.userData,
    }),
  },
  methods: {
    ...mapActions('feathers', ['logout']),
    ...mapMutations('authStore', ['CLEAR_USER_DATA']),
    async onLogout () {
      await this.logout()
      this.CLEAR_USER_DATA()
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style lang="scss" scoped>
header.nav-bar-container {
  height: 98px !important;
  width: 100%;
  padding: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;

  .nav-menu-item, .default-btn.text, .v-app-bar__nav-icon {
    color: white !important;
  }

  &.background-white {
    .nav-menu-item, .default-btn.text, .v-app-bar__nav-icon {
      color: $textDarkMuted !important;
    }
  }

  &.unscrolled {
    background: transparent !important;
  }

  &.scrolled {
    background-color: rgba($accentBlue, 0.85) !important;

    .nav-menu-item, .default-btn.text, .v-app-bar__nav-icon {
      color: white !important;
    }
  }

  nav {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    & > * {
      margin: 0 6px;
      padding: 5px 6px;
    }

    .signup {
      padding: 5px 0;
    }
  }
}

::v-deep {
  .v-toolbar__content {
    padding: 0;
  }

  .v-app-bar__nav-icon {
    margin-right: 0 !important;
    transform: scale(1.2);
  }
}
</style>
